import Header from "../../../component/header/Header";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/logisticaMezzi.json";

const MezziAnagrafiche = () => {
  const columns = [
    { field: "tipologiaMezzo", headerName: "Tipologia mezzo", width: 445 },
    { field: "targhe", headerName: "Targhe", width: 210 },
    { field: "posizione", headerName: "Posizione", width: 305 },
    { field: "km", headerName: "KM", width: 130 },
    { field: "creatoIl", headerName: "Da", width: 130 },
    { field: "a", headerName: "A", width: 130 },
    { field: "autore", headerName: "Autore", width: 85 },
    { field: "modDa", headerName: "Mod. da", width: 85 },
    { field: "stato", headerName: "Stato", width: 145 },
    { field: "azioni", headerName: "Azioni", width: 95 },
  ];

  return (
    <>
      <Header />
      <div className="pageTemplate">
        <Table data={tableData} columns={columns} navData={"mezziAnagrafiche"} />
      </div>
    </>
  );
};

export default MezziAnagrafiche;
